import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('identifier'),
    validators.requiredString('name.defaultValue'),
    validators.requiredNumber('order'),
    validators.requiredBoolean('isActive')
);

const useMakeFormValidator = () => useValidator(validator);

export default useMakeFormValidator;
